import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "item-overflow" }
const _hoisted_2 = {
  key: 0,
  class: "item-exterior"
}
const _hoisted_3 = { class: "volume-text" }
const _hoisted_4 = { class: "item-price" }
const _hoisted_5 = { class: "item-type" }
const _hoisted_6 = { class: "item-name" }
const _hoisted_7 = { class: "item-glow-top" }
const _hoisted_8 = {
  width: "300",
  height: "300",
  viewBox: "0 0 300 300",
  fill: "none"
}
const _hoisted_9 = { filter: "url(#filter0_fff)" }
const _hoisted_10 = ["fill"]
const _hoisted_11 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  class: "item-arrow"
}
const _hoisted_12 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcon = _resolveComponent("ItemIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inventory-item", { active: _ctx.active, selectable: _ctx.selectable, hover: _ctx.hover }]),
    style: _normalizeStyle({ '--color': _ctx.color })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "item-bg" }, null, -1)),
      (_ctx.exteriorNormalized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.exteriorNormalized), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["item-volume", { danger: _ctx.danger }])
      }, [
        _renderSlot(_ctx.$slots, "volume", {}, () => [
          _cache[0] || (_cache[0] = _createElementVNode("svg", {
            width: "15",
            height: "14",
            viewBox: "0 0 15 14",
            fill: "none",
            class: "volume-icon"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M12.3409 4.08333H1.8409C1.5189 4.08333 1.25757 3.822 1.25757 3.5V2.33333C1.25757 2.01133 1.5189 1.75 1.8409 1.75H12.3409C12.6629 1.75 12.9242 2.01133 12.9242 2.33333V3.5C12.9242 3.822 12.6629 4.08333 12.3409 4.08333Z",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M5.34094 6.41667H8.84094",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M12.1467 4.08334V11.0833C12.1467 11.7279 11.6246 12.25 10.98 12.25H3.20182C2.55724 12.25 2.03516 11.7279 2.03516 11.0833V4.08334",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.volumeNormalized), 1)
        ], true)
      ], 2),
      _createVNode(_component_ItemIcon, {
        icon: _ctx.icon,
        size: 260,
        zoom: _ctx.zoom,
        class: "item-image"
      }, null, 8, ["icon", "zoom"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.priceNormalized), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.typeNormalized), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock("svg", _hoisted_8, [
          _createElementVNode("g", _hoisted_9, [
            _createElementVNode("circle", {
              cx: "150",
              cy: "150",
              r: "23",
              fill: _ctx.color
            }, null, 8, _hoisted_10)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("defs", null, [
            _createElementVNode("filter", {
              id: "filter0_fff",
              x: "0",
              y: "0",
              width: "300",
              height: "300",
              filterUnits: "userSpaceOnUse",
              "color-interpolation-filters": "sRGB"
            }, [
              _createElementVNode("feFlood", {
                "flood-opacity": "0",
                result: "BackgroundImageFix"
              }),
              _createElementVNode("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "BackgroundImageFix",
                result: "shape"
              }),
              _createElementVNode("feGaussianBlur", {
                stdDeviation: "32",
                result: "effect1_foregroundBlur"
              })
            ])
          ], -1))
        ]))
      ]),
      (_openBlock(), _createElementBlock("svg", _hoisted_11, [
        _createElementVNode("path", {
          opacity: "0.5",
          d: "M6 12C2.68629 12 -1.00647e-07 9.31371 -2.24801e-07 6L-4.49603e-07 9.53674e-07L6 6L12 12L6 12Z",
          fill: _ctx.color
        }, null, 8, _hoisted_12)
      ])),
      _createElementVNode("div", {
        class: _normalizeClass(["item-overlay", { show: _ctx.showOverlay }])
      }, [
        _renderSlot(_ctx.$slots, "overlay", {}, undefined, true)
      ], 2),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "item-border" }, null, -1))
    ])
  ], 6))
}